
export { useCookie } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-grandiaziende-deploy-prod/libs/shared/hooks/src/lib/useCookie.ts"
export { useDeviceType } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-grandiaziende-deploy-prod/libs/shared/hooks/src/lib/useDeviceType.ts"